var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
    domProps: { value: _vm.$getCsrfToken() },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }